import { io } from 'socket.io-client';
import env from '../env.js';
// "undefined" means the URL will be computed from the `window.location` object
const URL = env.SOCKET_PATH;

export const socket = io(URL,{ autoConnect: false, transports: ["websocket"] , path:'/mysocket'});